import { ContentfulLivePreview } from '@contentful/live-preview';

import type { RouterLocale } from '~i18n/constants';

import { getContentfulLocale } from './utils';

export function initializeContentfulPreview(locale: RouterLocale) {
	void ContentfulLivePreview.init({
		enableInspectorMode: true,
		enableLiveUpdates: true,
		locale: getContentfulLocale(locale),
	});
	ContentfulLivePreview.subscribe('save', {
		callback() {
			window.location.reload();
		},
	});
}
